import { Link } from 'react-router-dom';
import * as style from '../../utils/general_style.js';

function FooterList({ listData }) {

	return (
        <div style={{color: style.COLORS.white, width: '100%'}}>
            <h3 style={{paddingBottom: '8px', textAlign: 'left'}}>{listData.title}</h3>
            {listData.routes.map(route => (
                <Link 
                    to={route.path}
                    key={route.label}
                    style={{height: 'auto', justifyContent: 'start', maxWidth: 'fit-content'}}> 
                        {(route.icon) ? <i className={route.icon} style={{padding: '0 5px 6px 0', fontSize: '14px'}}></i> : ''}<p style={{fontSize: '12px', paddingBottom: '6px', fontWeight: '100'}}>{route.label}</p>
                </Link>
            ))}
        </div>
	);
};

export default FooterList;